import { render } from "./BlankPage.vue?vue&type=template&id=5ca5cb84&ts=true"
import script from "./BlankPage.vue?vue&type=script&lang=ts"
export * from "./BlankPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__